import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Layout } from "@/components/Layout";

// Pages
import Home from "@/pages/Home";
import OmOss from "@/pages/OmOss";
import Kontakt from "@/pages/Kontakt";
import Personvern from "@/pages/Personvern";
import Vilkar from "@/pages/Vilkar";
import Prosjekter from "@/pages/Prosjekter";
import Blogg from "@/pages/Blogg";
import BloggPost from "@/pages/blogg/BloggPost";
import Admin from "@/pages/Admin";
import Takk from "@/pages/Takk";
import NotFound from "@/pages/NotFound";
// Tjenester
import Nettside from "@/pages/tjenester/Nettside";
import Annonsering from "@/pages/tjenester/Annonsering";
import SEO from "@/pages/tjenester/SEO";
import Nettbutikk from "@/pages/tjenester/Nettbutikk";
import Logodesign from "@/pages/tjenester/Logodesign";
import GoogleBedriftsprofil from "@/pages/tjenester/GoogleBedriftsprofil";
import Kampanje from "@/pages/Kampanje";


// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/admin" element={<Admin />} />
          <Route path="/*" element={
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/om-oss" element={<OmOss />} />
                <Route path="/prosjekter" element={<Prosjekter />} />
                <Route path="/blogg" element={<Blogg />} />
                <Route path="/blogg/:slug" element={<BloggPost />} />
                <Route path="/kontakt" element={<Kontakt />} />
                <Route path="/personvern" element={<Personvern />} />
                <Route path="/vilkar" element={<Vilkar />} />
                <Route path="/takk" element={<Takk />} />
                <Route path="/tjenester/nettside" element={<Nettside />} />
                <Route path="/tjenester/annonsering" element={<Annonsering />} />
                <Route path="/tjenester/seo" element={<SEO />} />
                <Route path="/tjenester/nettbutikk" element={<Nettbutikk />} />
                <Route path="/tjenester/logodesign" element={<Logodesign />} />
                <Route path="/tjenester/google-bedriftsprofil" element={<GoogleBedriftsprofil />} />
                <Route path="/trenger-nettside" element={<Kampanje />} />

                <Route path="*" element={<NotFound />} />
              </Routes>
            </Layout>
          } />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
